import React from 'react';
import "../css/BButton.css";

import Spinner from './Spinner.mjs';

class BButton extends React.Component {

    state = {
        loading: false
    };

    componentDidMount() {
        this._mounted = true;
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    isEnabled = () => (typeof this.props.enabled === "boolean") ? this.props.enabled : true;

    handleClick = async (e) => {
        if (this.state.loading || !this.isEnabled()) return;
        if (typeof this.props.onClick !== 'function') return;

        this.setState({ loading: true });
        // L-15: a rejected handler used to leave the button spinning forever.
        try {
            await this.props.onClick(e);
        } catch (err) {
            console.error("BButton onClick failed:", err);
        } finally {
            if (this._mounted) this.setState({ loading: false });
        }
    }

    handleKeyDown = (e) => {
        // L-13: make the div-button keyboard-operable.
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleClick(e);
        }
    }

    render() {
        return (
            <div
                className={"bbutton " + (this.props.className ? this.props.className : "")}
                data-enabled={this.isEnabled()}
                onClick={this.handleClick}
                onKeyDown={this.handleKeyDown}
                role="button"
                tabIndex={this.isEnabled() ? 0 : -1}
                aria-disabled={!this.isEnabled()}
                aria-label={this.props['aria-label']}
                title={this.props.title}
            >
                {
                    (this.state.loading) ? (
                        <Spinner inline />
                    ) : (
                        <>
                            {this.props.children}
                        </>
                    )
                }
            </div>
        );
    }
}

export default BButton;
